const pendingSaves = new WeakSet();

/** Keep cards in the underlying Mentions panel in sync without changing their collection or view. */
export function syncMentionChanges(model, selectedMention, originalCollection) {
    const original = originalCollection?.get(model.id) ?? (selectedMention.id === model.id ? selectedMention : null);
    if (!original) return;
    const changes = model.changedAttributes();
    if (changes) original.set(changes);
    if (!pendingSaves.has(model)) {
        pendingSaves.add(model);
        // Saving updates tags/Media directly, outside Model.set. This one-shot listener belongs
        // to the model, not the Vue view: a save can finish after the conversation is closed.
        model.once('sync', () => {
            pendingSaves.delete(model);
            original.set(model.attributes);
        });
    }
}

/** Missing publication dates sort first; equal dates preserve deterministic tree ordering by id. */
export const compareMentionsByPublishedDate = (a, b) => {
    const left = Date.parse(a.published) || 0;
    const right = Date.parse(b.published) || 0;
    return left === right ? 0 : left < right ? -1 : 1;
};

// Retained for older callers. A reply tree must be walked, not sorted with this pairwise comparator.
export const compareMentionsByReplyTo = (a, b) => {
    if (a.replyToId === b.id || a.reshareOfId === b.id) return 1;
    if (b.replyToId === a.id || b.reshareOfId === a.id) return -1;
    return compareMentionsByPublishedDate(a, b);
};
